import styled from 'styled-components';
import { timingDefault } from '../../constants';
export const StyledLink = styled.a(({ $variant, $color, $inheritTypography, theme }) => {
    const normalColor = $color === 'tertiary'
        ? theme.color.text.tertiary.on.background
        : $color === 'secondary'
            ? theme.color.text.secondary.on.background
            : $color === 'error'
                ? theme.color.text.critical.on.background
                : theme.color.text.primary.on.background;
    const hoverColor = theme.color.text.highContrast.on.background;
    return {
        'borderColor': normalColor,
        'borderStyle': 'solid',
        'borderWidth': 0,
        'borderBottomWidth': $variant === 'underline' ? theme.link.underline.lineWidth : 0,
        'color': normalColor,
        'cursor': 'pointer',
        'fontSize': $inheritTypography ? 'inherit' : theme.link.typography.fontSize,
        'fontWeight': $inheritTypography ? 'inherit' : theme.link.typography.fontWeight,
        'letterSpacing': $inheritTypography ? 'inherit' : theme.link.typography.letterSpacing,
        'paddingBottom': $variant === 'underline-on-hover' ? theme.link.underline.lineWidth : 0,
        'display': 'inline-block',
        '&:hover': {
            paddingBottom: $variant === 'underline' ? theme.link.underline.lineWidth : 0,
            borderBottomWidth: $variant === 'underline-on-hover' ? theme.link.underline.lineWidth : 0,
            borderColor: hoverColor,
            color: hoverColor,
        },
        'outline': 'none',
        'outline-color': `${theme.color.effect.focus.outline.on.background}`,
        'outline-offset': `calc(${theme.spacing(1)} / 2)`,
        'outline-width': `calc(${theme.spacing(1)} / 2)`,
        '&:focus-visible': {
            'outline-style': 'solid',
        },
    };
});
export const IconWrapper = styled.span(({ position, theme: { color, link, spacing } }) => ({
    'display': 'inline-block',
    'margin': `0 ${spacing(2)}`,
    'transform': `translateX(0) rotate(${position === 'left' ? 180 : 0}deg)`,
    'transition': `transform ${timingDefault} ease-in-out`,
    '> svg > g': {
        stroke: color.deprecated.obsidian,
    },
    '> svg': {
        width: 'auto',
    },
    [`${StyledLink}:hover &`]: {
        'transform': `translateX(${position === 'left' ? -4 : 4}px) rotate(${position === 'left' ? 180 : 0}deg)`,
        '> svg > g': {
            stroke: link.color.hover,
        },
    },
    '.rtl &': {
        transform: `rotate(${position !== 'left' ? 180 : 0}deg)`,
    },
    [`.rtl ${StyledLink}:hover &`]: {
        transform: `translateX(${position !== 'left' ? -4 : 4}px) rotate(${position !== 'left' ? 180 : 0}deg)`,
    },
}));
//# sourceMappingURL=styles.js.map